"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _fns = require("@react-pdf/fns");

var _dropLast = _interopRequireDefault(require("../run/dropLast"));
/**
 * Drop last glyph
 *
 * @param {Object} attributed string
 * @return {Object} attributed string with new glyph
 */


var dropLast = function dropLast(attributeString) {
  var string = (0, _fns.dropLast)(attributeString.string);
  var runs = (0, _fns.adjust)(-1, _dropLast["default"], attributeString.runs);
  return Object.assign({}, attributeString, {
    string: string,
    runs: runs
  });
};

var _default = dropLast;
exports["default"] = _default;